import { Navigate, Route, Routes } from 'react-router-dom';
import { Keyed } from '../../shared/components/Common';
import HotelSearch from './HotelSearch';
import HotelList from './HotelList';
import HotelDetails from './HotelDetails';
import HotelReview from './HotelReview';
import HotelConfirmation from './HotelConfirmation';
import HotelBookings from './HotelBookings';
import HotelBookingDetails from './HotelBookingDetails';

// Mounted at /hotels/*
export default function HotelRoutes() {
  return (
    <Routes>
      <Route index element={<HotelSearch />} />
      <Route path="results" element={<Keyed page={HotelList} />} />
      <Route path="hotel" element={<Keyed page={HotelDetails} />} />
      <Route path="review" element={<HotelReview />} />
      <Route path="confirmation/:bookingId" element={<HotelConfirmation />} />
      <Route path="bookings" element={<HotelBookings />} />
      <Route path="bookings/:bookingId" element={<HotelBookingDetails />} />
      <Route path="*" element={<Navigate to="/hotels" replace />} />
    </Routes>
  );
}
